import { useLocation, Link } from "react-router-dom";
import classnames from "classnames";
import styles from "./AgenticPlatformNavTabs.module.css";

export function AgenticPlatformNavTabs() {
  const location = useLocation();
  const isCapabilityCatalogActive =
    location.pathname.includes("/capability-catalog");
  const isAgentCatalogActive = !isCapabilityCatalogActive;

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabList}>
        <Link
          to="/agentic-platform/agent-catalog"
          className={classnames(styles.tab, {
            [styles.activeTab]: isAgentCatalogActive,
          })}
        >
          Agent Catalog
        </Link>
        <Link
          to="/agentic-platform/capability-catalog"
          className={classnames(styles.tab, {
            [styles.activeTab]: isCapabilityCatalogActive,
          })}
        >
          Capability Catalog
        </Link>
      </div>
    </div>
  );
}
